module.exports = __webpack_public_path__ + "static/media/Paladin_Ret.9f41fa79.png";